import { LitElement, html } from 'lit';
import { property, state } from 'lit/decorators.js';
import { customElement } from 'lit/decorators/custom-element.js';
import {unsafeHTML} from 'lit/directives/unsafe-html.js';
import {oipBenefitStyle} from "@/components/oip-benefit/oip-benefit.style.ts";

// eslint-disable-next-line
declare const TYPO3: any;

@customElement('sbk-oip-benefit')
export class SbkBenefit extends LitElement {

    static shadowRootOptions = {...LitElement.shadowRootOptions, delegatesFocus: true};

    @property({attribute: 'long-description'})
    longDescription = '';

    @property({attribute: 'short-description'})
    shortDescription = '';

    @state()
    expanded: boolean = false;

    connectedCallback() {
        super.connectedCallback();
        const swiper = this.closest('swiper-container[variant="leadmanagement"]')
        swiper?.addEventListener('leadmanagement-slider-slide-change', () => {
            this.expanded = false
        });
    }

    static get styles() {
        return oipBenefitStyle;
    }

    render() {
        return html`
            <div class="short-description">${unsafeHTML(this.shortDescription)}</div>
            <div class="long-description${this.expanded ? ' long-description--expanded' : ''}">${unsafeHTML(this.longDescription)}</div>
            <sbk-button @click=${this._toggleState} variant="secondary" icon-position="right" icon=${this.expanded ? 'chevron-up' : 'chevron-down'}>${this._getMessage(this.expanded ? 'showLess' : 'showMore')}</sbk-button>
    `;
    }

    _toggleState() {
        this.expanded = !this.expanded
    }

    _getMessage(key: string): string {
        return typeof TYPO3 !== "undefined" ? TYPO3.lang[key] : key;
    }
}
